import VueRouter from 'vue-router';

const router = new VueRouter({
	base:'/',
	mode:'history',
	routes: [
		{
			path: '/',  
			redirect: '/home',
			name: 'Home',
			component: () => import('../page/index.vue'),
		},
		{
			path: '/home',  
			name: 'Home',
			component: () => import('../page/index.vue'),
		},
		{
			path: '/about',  
			name: 'About',
			component: () => import('../page/about.vue'),
		},
		{
			path: '/innovation',  
			name: 'Innovation',
			component: () => import('../page/innovation.vue'),
		},
		{
			path: '/case',  
			name: 'Case',
			component: () => import('../page/case.vue'),
		},
		{
			path: '/news',  
			name: 'News',
			component: () => import('../page/news.vue'),
		},
		{
			path: '/detail1',
			name: 'Detail',
			component: () => import('../page/detail1.vue'),
		},
		{
			path: '/detail2',
			name: 'Detail',
			component: () => import('../page/detail2.vue'),
		},
		{
			path: '/contact',  
			name: 'Contact',
			component: () => import('../page/contact.vue'),
		},
		{
			path: '/login',  
			name: 'Login',
			component: () => import('../page/login.vue'),
		}
	]
})

export default router